export const parseQuery = (queryString) => {
  const pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');

  return pairs.reduce((query, item) => {
    const [key, value] = item.split('=');
    query[decodeURIComponent(key).toLowerCase()] = decodeURIComponent(value || '');
    return query;
  }, {});
};
